// Single source of truth for "should this task show an active Done button?"
// Reads completion_mode + auto_complete_action + navigation_target that the
// backend now injects on every task response.
//
// Task object contract (backend-populated):
//   completion_mode:        "manual" | "system-action"
//   auto_complete_action:   string | null   ("a PO is created against this indent")
//   navigation_target:      { label: string, path: string } | null
//
// This is a PURE function (not a React hook) — safe to call inside loops and
// conditionals. Named without the `use*` prefix so it does not trigger the
// react-hooks lint rule.

export function getTaskCompletionBehavior(task) {
  if (!task) {
    return { canManuallyComplete: false, autoCompleteMessage: null, navigationTarget: null, completionMode: 'manual' };
  }
  const mode = task.completion_mode === 'system-action' ? 'system-action' : 'manual';
  const canManuallyComplete = mode === 'manual';
  const autoCompleteMessage = task.auto_complete_action
    ? `Auto-completes when ${task.auto_complete_action}`
    : null;
  const navigationTarget = task.navigation_target || null;
  return { canManuallyComplete, autoCompleteMessage, navigationTarget, completionMode: mode };
}

// Back-compat alias. Kept so callsites can migrate gradually.
export const useTaskCompletionBehavior = getTaskCompletionBehavior;
